import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useLanguageUpdate = () => {
    const { i18n } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = React.useState(i18n.language);

    const handleLanguageChanged = (lng) => {
        setCurrentLanguage(lng);
    };

    useEffect(() => {
        i18n.on('languageChanged', handleLanguageChanged);

        return () => {
            i18n.off('languageChanged', handleLanguageChanged);
        };
    }, [i18n]);

    return {
        currentLanguage,
        isSlavic: currentLanguage === 'ru' || currentLanguage === 'uk',
    };
};

export default useLanguageUpdate;
